module.exports = __webpack_public_path__ + "img/fc_logo.71386cd8.png";